import ListSubheader from '@components/v2/ui/List/ListSubheader';
import { Divider } from '@mui/material';
import useWidth from '../../components/Hooks/useWidth';
import LangEnum from '../../lang/LangEnum';
import { HighlightsTestIds } from '../../utils/testIds/Highlights.testIds';
import { useTranslation } from '../translation/TranslationContext';
import HighlightModal from './HighlightModal';
import HighlightMenuItem from './components/HighlightMenuItem';
import { useHighlights } from './hooks/useHighlights';

const HighlightsMenuSection = () => {
  const { translate } = useTranslation();
  const { smallWidth } = useWidth();
  const { highlights, openedHighlight, isHighlightOpen, isRead, openHighlight, closeHighlight } =
    useHighlights();

  if (!smallWidth || !highlights.length) {
    return null;
  }

  return (
    <>
      <Divider sx={(theme) => ({ my: theme.spacing(0.5) })} />

      <ListSubheader testId={HighlightsTestIds.MENU_SECTION}>
        {translate(LangEnum.HIGHLIGHTS_MENU_SECTION)}
      </ListSubheader>

      {highlights.map((highlight) => (
        <HighlightMenuItem
          key={highlight.id}
          title={highlight.title}
          isRead={isRead(highlight.id)}
          testId={`${HighlightsTestIds.MENU_ITEM_PREFIX}${highlight.id}`}
          onClick={() => openHighlight(highlight)}
        />
      ))}

      <HighlightModal
        isOpen={isHighlightOpen}
        highlight={openedHighlight}
        onClose={closeHighlight}
      />
    </>
  );
};

export default HighlightsMenuSection;
